import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
    let testimonialsSwiper;

    const initializeTestiSwiper = () => {
        testimonialsSwiper = new Swiper('#testimonials-sidebar-slider', {
            modules: [Navigation, Pagination, A11y],
            navigation: {
                nextEl: '.testimonial-arrow-next',
                prevEl: '.testimonial-arrow-prev',
            },
            a11y: true,
            keyboardControl: true,
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 90,
            loop: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            autoHeight: true,
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                992: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                1024: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                1440: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
            },
        });

    };

    // Recalculate Swiper dimensions and reset instance
    const resetTestiSwiper = () => {
        if (testimonialsSwiper && testimonialsSwiper.destroy) {
            testimonialsSwiper.destroy(true, true);
        }
        initializeTestiSwiper(); // Re-initialize Swiper
    };

    // Force recalculation of layout after resize/orientation change
    const handleResize = () => {
        resetTestiSwiper(); // Reinitialize Swiper after resize or orientation change
        testimonialsSwiper.update(); // Force update Swiper layout
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    // Initialize on load
    initializeTestiSwiper();
};